<script lang="ts">
  import { tStore } from '../../../i18n'
  import type { TenderFilter } from '../../../api/tenderFilters'

  let {
    target,
    isActive,
    defaultFilterName,
    inFlight,
    onConfirm,
    onCancel,
  }: {
    target: TenderFilter | null
    isActive: boolean
    defaultFilterName: string | undefined
    inFlight: boolean
    onConfirm: () => void
    onCancel: () => void
  } = $props()
</script>

{#if target}
  <!-- svelte-ignore a11y_click_events_have_key_events a11y_no_static_element_interactions -->
  <div class="dialog-backdrop" onclick={onCancel}>
    <div
      class="dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="filter-delete-dialog-title"
      tabindex="-1"
      onclick={(e) => e.stopPropagation()}
    >
      <h3 id="filter-delete-dialog-title">{$tStore('views.tenderFilters.deleteConfirmTitle')}</h3>
      <p class="dialog__body">{target.name}</p>
      <p class="dialog__hint">{$tStore('views.tenderFilters.deleteConfirmBody')}</p>
      {#if isActive && defaultFilterName}
        <p class="dialog__hint">
          {$tStore('views.tenderFilters.deleteConfirmActiveBody', { name: defaultFilterName })}
        </p>
      {/if}
      <div class="dialog__actions">
        <button type="button" class="btn btn--secondary" onclick={onCancel} disabled={inFlight}>
          {$tStore('common.cancel')}
        </button>
        <button type="button" class="btn btn--danger" onclick={onConfirm} disabled={inFlight}>
          {inFlight ? $tStore('common.loading') : $tStore('views.tenderFilters.actions.delete')}
        </button>
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  @use '../../../assets/styles/variables' as v;

  .dialog-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .dialog {
    background: v.$color-surface-elevated;
    border: 1px solid v.$color-border;
    border-radius: v.$radius-lg;
    box-shadow: v.$shadow-lg;
    padding: v.$space-lg;
    max-width: 28rem;
    width: calc(100% - 2rem);

    h3 {
      margin: 0 0 v.$space-sm;
      font-size: 1.125rem;
    }
  }

  .dialog__body {
    font-weight: 600;
    margin: 0 0 v.$space-xs;
    word-break: break-word;
  }

  .dialog__hint {
    color: v.$color-text-muted;
    font-size: 0.875rem;
    margin: 0 0 v.$space-sm;

    &:last-of-type {
      margin-bottom: v.$space-lg;
    }
  }

  .dialog__actions {
    display: flex;
    justify-content: flex-end;
    gap: v.$space-sm;
  }
</style>
